import React, { Component, useState, Fragment } from "react";
import Cookies from 'js-cookie'

import Header from './Header.js';
import Footer from './Footer.js';
import Body from "./Body.js";

import {addCmListFunction} from '../cm_parts/js/CmListFunction';

import settings from '../../settings.json';


export default class Orverseas extends Component{
  state={

  }


  onUnload = (e) => { // the method that will be used for both add and remove event
    const confirmationMessage = 'Some message';
    e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
    console.log('LEAVE');
    addCmListFunction.saveStaffInOut(this.state, 'out');
    console.log('LEAVE SAVED');
    //return confirmationMessage;   
    //alert('HELO');
  }
  
  componentDidMount () {
    let my_token = Cookies.get('_replace_token');
    if(my_token===undefined){
      window.location.href = '/login';
    }


    var url = settings.API_ENDPOINT_URL;

    const getDBData = async () => {
      //https://api.hello-remix.com/users?limit=3
      const res = await fetch(
        url + '/users/?limit=3'
      );
      const data = await res.json();
      //console.dir(data);

    };

    getDBData();

    window.addEventListener("beforeunload", this.onUnload);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onUnload);
  }






  render(){
    return (
      <div className="orverseas mb-5 px-3 py-2" >

        <Header // tonya
          data={this.state}
        />

        <Body
          data={this.state}
        />



        <Footer
          data={this.state} 
        />



      </div>
    );
  }
}

